// @ts-ignore
import {DotLottie} from "@lottiefiles/dotlottie-web";
import TomSelect from "tom-select";

document.addEventListener('DOMContentLoaded', () => {
    const canvas = document.querySelector<HTMLCanvasElement>('canvas.logo');
    if (!canvas) return;

    const src = canvas.getAttribute('data-lottie-src');
    if (!src) return;

    new DotLottie({
        autoplay: true,
        loop: true,
        canvas,
        src,
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const flavorSelects = document.querySelectorAll<HTMLSelectElement>('[data-flavor-select]');

    flavorSelects.forEach(select => {
        const otherRow = select.closest('.input-row')?.nextElementSibling as HTMLElement | null;
        const otherInput = otherRow?.querySelector('input');
        if (!otherRow || !otherInput) return;

        const toggleOtherRow = (values: string[]) => {
            const isOther = values.includes('other');
            otherRow.hidden = !isOther;
            otherInput.required = isOther;
        };

        const maxItems = parseInt(select.dataset.maxItems ?? '', 10);

        const tomSelect = new TomSelect(select, {
            plugins: ['remove_button'],
            placeholder: 'Selecteer een of meerdere smaken',
            maxItems: Number.isNaN(maxItems) ? null : maxItems,
            onChange: toggleOtherRow,
        });

        toggleOtherRow(tomSelect.items);
    });
});
